import React from "react";
import {Button} from "antd";
import {useNavigate} from "react-router-dom"

import cardStyles from "./cardGroup.module.scss";
import {pathRoutes} from "../../../props/util.props";
import {camSearchParam} from "../../videoCall/VideoConference/utils/janusUtils";

const ConferenceCard = (props: any) => {
    const navigate = useNavigate();

    const joinConference = () => {
        navigate(pathRoutes.conference + "?id=" + props.id + "&" + camSearchParam + "=true");
    };

    return (
        <div
            className={cardStyles.card}
            style={{
                backgroundImage: `url(${props.coverImgURL})`,
                backgroundSize: "cover",
            }}
        >
            <div
                style={{
                    display: "inline-flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
            >
                {/*<div className={cardStyles.profile}>*/}
                {/*    <div*/}
                {/*        className={cardStyles.profileInner}*/}
                {/*        style={{ backgroundImage: `url(${profile})` }}*/}
                {/*    ></div>*/}
                {/*</div>*/}
                {/* <img className={cardStyles.profile} src={profile} alt="profile" /> */}
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div className={cardStyles.live}>● LIVE</div>
                    {/*<div className={cardStyles.view}>*/}
                    {/*    <EyeOutlined />*/}
                    {/*    1k*/}
                    {/*</div>*/}
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >

                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                    }}
                >
                    {/*<div className={cardStyles.cardDetail}>{"(10k peaple)"}</div>*/}
                    <div className={cardStyles.headCardDetail}>{props.name}</div>
                    <Button className={cardStyles.watchBotton} onClick={joinConference}>
                        join
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ConferenceCard;
